import NavRouter from './router/NavRouter';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
// import "aos/dist/aos.css";
// import AOS from "aos";
// import "slick-carousel/slick/slick.css"; 
// import "slick-carousel/slick/slick-theme.css"; 
import "./index.css";
import "./responsive.css";
import SEO from "./helper/SEO";
import { useState } from "react";
import { BaseUrl } from './helper/BaseUrl';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';

function App({initialData, initialSeo, initialSchema}) {
  const [seoData, setSeoData] = useState(initialSeo || null);
  const [schemaData, setSchemaData] = useState(initialSchema || null);
  const location = useLocation();
  const initialPathRef = React.useRef(location.pathname);
  const routeInitialData =
    location.pathname === initialPathRef.current ? initialData : undefined;
  //   useEffect(() => {
  //      AOS.init({ duration: 1000 });
  //   }, []);

  //   useEffect(() => {
  //     AOS.refresh(); 
  //   }, [location.pathname]);

  //   useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.visibilityState === "visible") {
  //       AOS.refresh(); // retriggers animations if needed
  //     }
  //   };

  //   document.addEventListener("visibilitychange", handleVisibilityChange);

  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, []);



  const Detailfetcher = async () => {
    try {
      const response = await fetch(`${BaseUrl}/api/seo-by-url${location.pathname}`, {
        method: 'GET',
      });
      const result = await response.json();
      if (result.seo === false) {
        throw new Error(`API error: ${result.message}`);
      }
      setSeoData(result.seo);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    if (
      location.pathname === initialPathRef.current &&
      initialSeo &&
      Object.keys(initialSeo).length > 0
    ) {
      setSeoData(initialSeo);
      return;
    }
    Detailfetcher();
  }, [location.pathname, initialSeo])

  useEffect(() => {
    if (
      initialSchema &&
      Object.keys(initialSchema).length > 0
    ) {
      setSchemaData(initialSchema);
      return undefined;
    }

    const fetchSchema = async () => {
      try {
        const response = await fetch(`${BaseUrl}/api/global-seo`, {
          method: 'GET',
        });
        const result = await response.json();
        setSchemaData(result.schema);
      } catch (error) {
        console.error('Schema fetch error:', error.message);
      }
    };

    if (typeof window !== "undefined" && "requestIdleCallback" in window) {
      const idleId = window.requestIdleCallback(fetchSchema, { timeout: 5000 });
      return () => window.cancelIdleCallback(idleId);
    }

    const timer = setTimeout(fetchSchema, 3000);
    return () => clearTimeout(timer);
  }, [initialSchema]);

  const NormalizeTrailingSlash = () => {
    const location = useLocation();

    useEffect(() => {
      if (location.pathname !== '/' && location.pathname.endsWith('/')) {
        window.history.replaceState(
          null,
          '',
          location.pathname.slice(0, -1) + location.search + location.hash
        );
      }
    }, [location]);

    return null;
  };

  return (

    <>
      <div className="App">
        <SEO seoData={seoData} initialSeo={initialSeo} schemaData={schemaData} initialSchema={initialSchema}/>
        <NormalizeTrailingSlash />
        <ToastContainer />
        <NavRouter initialData={routeInitialData} />
      </div>
    </>

  );
}

export default App;
